import IdentitySelector from './IdentitySelector';

export default IdentitySelector;
